import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Home from './pages/Home'
import ContactUs from './pages/ContactUs'
import Events from './pages/Events'
import Banquet from './pages/Banquet'
import Inquiry from './pages/Inquiry'
import Room from './pages/Room'
import Offer from './pages/Offer'
import Gallery from './pages/Gallery'
import About from './pages/About'
import Restaraunt from "./pages/Restaraunt";
import RestarauntMenu from "./pages/RestarauntMenu";
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/events" element={<Events />}></Route>
          <Route path="/halls" element={<Banquet />}></Route>
          <Route path="/inquiry" element={<Inquiry />}></Route>
          <Route path="/room" element={<Room />}></Route>
          <Route path="/contact" element={<ContactUs />}></Route>
          <Route path="/offer" element={<Offer/>}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/restaraunt" element={<Restaraunt />}></Route>
          <Route path="/menu" element={<RestarauntMenu />}></Route>
          </Routes>
          </Router>
    </div>
  );
}

export default App;
